import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../publisher/style/Sidebar.css';

const Sidebar = ({ isOpen, toggle, currentPath, role }) => {
    const navigate = useNavigate();
    const [expandedMenu, setExpandedMenu] = useState(null);

    // --- Logout Logic ---
    const handleLogout = () => {
        // 1. Clear Cookie
        document.cookie = "adminToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        // 2. Clear LocalStorage (if used)
        localStorage.removeItem('pub_auth');
        // 3. Redirect
        navigate('/login');
    };

    const handleMenuClick = (path, hasSubs, menuName, isLogout) => {
        if (isLogout) {
            handleLogout();
            return;
        }

        if (hasSubs) {
            setExpandedMenu(expandedMenu === menuName ? null : menuName);
        } else {
            navigate(path);
            if (window.innerWidth < 768) toggle();
        }
    };

    // --- MODERN ICONS (SVG Paths) ---
    const icons = {
        dashboard: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z",
        offers: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z",
        reports: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
        chart: "M3 3v18h18 M18 17V9 M13 17V5 M8 17v-3",
        account: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
        campaign: "M12 2L1 21h22L12 2zm0 3.45l8.27 14.3H3.73L12 5.45z M11 10h2v6h-2z M11 18h2v2h-2z",
        logout: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9",
        link: "M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1 M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 0 1-7-7l1-1"
    };

    const menus = [
        {
            name: 'Dashboard',
            path: '/cbMediaAdmin7',
            icon: <PathIcon d={icons.dashboard} />
        },
        {
            name: 'Offers',
            icon: <PathIcon d={icons.offers} />,
            subs: [
                { name: 'All Offers', path: '/cbMediaAdmin7/offers' },
                { name: 'Offer Approval', path: '/cbMediaAdmin7/offers/request' }
            ]
        },
        {
            name: 'Reports',
            icon: <PathIcon d={icons.chart} />,
            subs: [
                { name: 'Offer Wise', path: '/cbMediaAdmin7/reports/offer' },
                { name: 'Publisher Wise', path: '/cbMediaAdmin7/reports/publisher' },
                { name: 'Performance', path: '/cbMediaAdmin7/reports/performance' }
            ]
        },
        {
            name: 'Publishers',
            icon: <PathIcon d={icons.account} />,
            subs: [
                { name: 'Manager Publisher', path: '/cbMediaAdmin7/publishers/manage' },
                { name: 'Advance Publisher', path: '/cbMediaAdmin7/publishers/advance' },
                { name: 'Manage Billing', path: '/cbMediaAdmin7/publishers/billing' }
            ]
        },
        {
            name: 'Settings',
            path: '/cbMediaAdmin7/settings',
            icon: <PathIcon d={icons.link} />,
 },
        {
            name: 'Import Lead',
            path: '/cbMediaAdmin7/import',
            icon: <PathIcon d={icons.reports} />,
 },
        {
            name: 'Logout',
            // Removed path, logic handled in onClick
            icon: <PathIcon d={icons.logout} />,
            isLogout: true
        }
    ];

    return (
        <>
            <div
                className={`sidebar-overlay-unique ${isOpen ? 'active' : ''}`}
                onClick={toggle}
            ></div>

            <div className={`sidebar-container-unique ${isOpen ? 'open' : ''}`}>

                <div className="sidebar-header-unique">
                    <h2 className="site-title-unique animated-breath-unique">
                        CashBolt<span className="accent-text">Media</span>
                    </h2>
                </div>

                <div className="sidebar-menu-wrapper">
                    {menus.map((menu, index) => {
                        const isMainActive = currentPath === menu.path;
                        const isChildActive = menu.subs && menu.subs.some(s => s.path === currentPath);
                        const isActive = isMainActive || isChildActive;
                        const isExpanded = expandedMenu === menu.name || isChildActive;

                        return (
                            <div key={index} className="menu-group-unique">
                                {/* Main Item */}
                                <div
                                    className={`menu-item-unique ${isActive ? 'active-main' : ''} ${menu.isLogout ? 'logout-item' : ''}`}
                                    onClick={() => handleMenuClick(menu.path, !!menu.subs, menu.name, menu.isLogout)}
                                >
                                    {/* Active Glow Indicator */}
                                    {isActive && <div className="active-glow-bar"></div>}

                                    <span className="menu-icon-box">{menu.icon}</span>
                                    <span className="menu-text">{menu.name}</span>

                                    {menu.subs && (
                                        <span className={`arrow-icon ${isExpanded ? 'rotated' : ''}`}>
                                            ›
                                        </span>
                                    )}
                                </div>

                                {/* Sub Menus */}
                                {menu.subs && (
                                    <div className={`submenu-wrapper-unique ${isExpanded ? 'expanded' : ''}`}>
                                        <div className="tree-line-unique"></div>
                                        <div className="submenu-content-unique">
                                            {menu.subs.map((sub, subIndex) => (
                                                <div
                                                    key={subIndex}
                                                    className={`submenu-item-unique ${currentPath === sub.path ? 'active-sub' : ''}`}
                                                    onClick={() => {
                                                        navigate(sub.path);
                                                        if (window.innerWidth < 768) toggle();
                                                    }}
                                                >
                                                    <span className="tree-branch-unique"></span>
                                                    <span className="sub-text">{sub.name}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div className="sidebar-footer-unique">
                    <a href="https://t.me/legendfbd" target="_blank" rel="noreferrer" className="legend-link">
                        <span className="code-icon">⚡</span> Developed by <span className="dev-name">Legend</span>
                    </a>
                </div>
            </div>
        </>
    );
};

const PathIcon = ({ d }) => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d={d}></path>
    </svg>
);

export default Sidebar;